// A store on a server in memory: the real store and sync, no Firebase. For the demo (`?demo`), the screens' tests,
// and the data layer's own tests.

import type { Fields } from "../core/records";
import { memoryCache } from "./cache";
import { MemoryRemote } from "./memoryRemote";
import { Store, type StoreOptions } from "./store";
import { Sync, type SyncProblem } from "./sync";

export interface MemoryStore {
  store: Store;
  sync: Sync;
  remote: MemoryRemote;
}

/**
 * A store for `uid` whose server holds `documents` (by path, as stored: `users/{uid}/todos/{ID}` → fields; Dates are
 * stored as moments). Call `store.start()`; it is ready a moment later.
 */
export function memoryStore(
  options: { uid?: string; documents?: Record<string, Fields>; remote?: MemoryRemote; onProblem?: (problem: SyncProblem) => void } & Omit<StoreOptions, "uid" | "backend"> = {},
): MemoryStore {
  const { uid = "demo", documents = {}, remote = new MemoryRemote(), onProblem, ...storeOptions } = options;
  for (const [path, data] of Object.entries(documents)) remote.put(path, data);
  const sync = new Sync({ uid, remote, cache: memoryCache(remote.values), ...(onProblem ? { onProblem } : {}) });
  const store = new Store({ ...storeOptions, uid, backend: sync });
  return { store, sync, remote };
}
